module.exports = __webpack_public_path__ + "static/profile-1d91a937a288ea1d42864f18f69ae3fc.jpg";